import React from 'react';
import { FormatComponentProps } from './types';

const CodeBlock: React.FC<FormatComponentProps> = ({ content, formulaSelected }) => {
  const code = content.replace(/^```[\w]*\n?/, '').replace(/```$/, '');
  return (
    <div onClick={() => formulaSelected?.(code)}>
      <strong>
        <span
          style={{
            padding: '4px',
            cursor: 'pointer',
            wordWrap: 'break-word',
            overflowWrap: 'break-word',
            wordBreak: 'break-word',
            whiteSpace: 'pre-wrap'
          }}
        >
          {code}
        </span>
      </strong>
    </div>
  );
};

export default CodeBlock;
